import React from 'react'
import styled from 'styled-components'
import { RatingDistribution } from 'lib/RatingDistribution'
import { StarRating } from 'lib/StarRating'
import { Text } from 'lib/Text'

const Rating = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 2px;
`

const Description = styled(Text)`
  margin-bottom: 16px;
`

interface Props {
  className?: string
  averageRating: number
  totalReviews: number
  ratingDistributions: {
    [key: string]: number
  }[]
}

export const ReviewRatingAverage = ({ className, averageRating, totalReviews, ratingDistributions }: Props) => {
  return (
    <article className={className}>
      <Rating>
        <Text as="span" size="m" weight="medium">
          {averageRating}
        </Text>
        <StarRating stars={averageRating} />
      </Rating>

      <Description as="h3" size="ps">
        Average rating from {totalReviews} reviews
      </Description>

      <RatingDistribution total={totalReviews} ratingDistribution={ratingDistributions} />
    </article>
  )
}
